import { Drivers } from "modules/drivers";

const CompanyAdminDriversPage = () => <Drivers />;

export default CompanyAdminDriversPage;
